import type { UseFormReturn } from 'react-hook-form';
import { FormProvider as RHFFormProvider } from 'react-hook-form';

type Props = {
  children: React.ReactNode;
  // eslint-disable-next-line ts/no-explicit-any
  methods: UseFormReturn<any>;
  onSubmit?: VoidFunction;
  className?: string;
};

function FormProvider({ children, onSubmit, methods, className = 'w-full' }: Props) {
  const handleSubmit
    = onSubmit !== undefined
      ? methods.handleSubmit(() => {
          onSubmit();
        })
      : undefined;

  return (
    <RHFFormProvider {...methods}>
      {handleSubmit !== undefined
        ? (
            <form onSubmit={handleSubmit} className={className} noValidate>
              {children}
            </form>
          )
        : (
            <div className={className}>
              {children}
            </div>
          )}
    </RHFFormProvider>
  );
}

export default FormProvider;
